import styled, { CSSObject } from 'styled-components';
import { getIconSize, getPadding } from '../utils/stylingFunctions';

export const StoryWrapper = styled.div<{ maxWidth?: number }>`
  max-width: ${(props) => props.maxWidth ?? 640}px;
  padding-left: 40px;
  margin-top: 40px;
  * {
    box-sizing: border-box;
  }
`;

export const StoryContainer = styled.div`
  padding: 20px 0px;
`;

export const StoryTitle = styled.h1`
  ${(props) => props.theme.newTypography.textStyleDisplayLarge}
  color: ${(props) => props.theme.newPalette.neutral.N1000};
`;

export const StyledHeader = styled.h2`
  ${(props) => props.theme.newTypography.textStyleDisplayLarge}
  color: ${(props) => props.theme.newPalette.neutral.N1000};
`;

export const StyledSubheader = styled.h3`
  ${(props) => props.theme.newTypography.textStyleHeading}
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;

export const StyledText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody}
  color: ${(props) => props.theme.newPalette.neutral.N600};
`;

export const StyledTextLarge = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodyLarge}
  color: ${(props) => props.theme.newPalette.neutral.N700};
  margin: 0;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.newPalette.neutral.N600};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const ContainerWithBorder = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N500};
  margin-bottom: 60px;
`;

export const GreyTextContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.neutral.N200};
  border-radius: 4px;
  padding: 7px 20px;
  width: auto;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  row-gap: 40px;
`;

export const GridColumnOne = styled.div<{
  gridRow: number;
}>`
  display: grid;
  grid-column: 1/6;
  grid-row: ${(props) => props.gridRow};
`;

export const GridColumnTwo = styled.div<{
  gridRow: number;
}>`
  display: grid;
  grid-column: 7/12;
  grid-row: ${(props) => props.gridRow};
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledIcon = styled.i<{
  color?: string;
  size?: string;
  padding?: string;
  isClickable?: boolean;
}>`
  display: inline-block;
  padding: ${(props) => props.padding};
  padding-top: calc(${({ size }) => size}*0.06);
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
  line-height: 1;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
`;

export const StyledIconInButton = styled.i<{
  size: 'small' | 'medium' | 'large';
  position: 'left' | 'right';
  color?: string;
  customStyle?: CSSObject;
}>`
  font-size: ${(props) => getIconSize(props.size)};
  display: inline-block;
  line-height: 1;
  align-self: center;
  color: ${(props) => (props.color ? props.color : 'inherit')};
  padding-left: ${(props) => {
    if (props.position === 'right') {
      return getPadding(props.size);
    } else {
      return '0px';
    }
  }};
  padding-right: ${(props) => {
    if (props.position === 'left') {
      return getPadding(props.size);
    } else {
      return '0px';
    }
  }};
  padding-top: calc(${({ size }) => getIconSize(size)}*0.06);
  ${(props) => (props.customStyle ? props.customStyle : '')}
`;

export const StyledLabel = styled.label<{ disabled?: boolean }>`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.atlas.semantic.color.type.muted
      : theme.atlas.semantic.color.type.default};
`;
